export default {
  computed: {
    findPropertyQuestion() {
      return this.question.Questions.find((q) =>
        q.InterfaceKey.endsWith("FindProperty")
      );
    },
    otherAddressQuestions() {
      return this.question.Questions.filter(
        (q) => !q.InterfaceKey.endsWith("FindProperty")
      );
    },
  },
};
